import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";

import { MailMergeAccessSection } from "@/common/components/mail-merge-access/MailMergeAccessSection";
import { useTranslation } from "@/translations";

import { ClientFileColorCodingSetting } from "./components/client-file-color-coding-setting/ClientFileColorCodingSetting";

interface Props {
  onClose: () => void;
}

export function UserSettingsDialog({ onClose }: Props) {
  const { t } = useTranslation();

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{ p: 5, pb: 3, display: "flex", alignItems: "center", justifyContent: "space-between" }}
        variant="h1"
      >
        {t("layout.header.userSettings")}
        <IconButton onClick={onClose} aria-label={t("common.close")}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 5, pt: 0 }}>
        <Stack spacing={2}>
          <ClientFileColorCodingSetting />
          <MailMergeAccessSection />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 5, pt: 0, justifyContent: "flex-start" }}>
        <Button variant="outlined" onClick={onClose}>
          {t("common.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
